"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./Field.css");

function Field(props) {
  var children = props.children,
      className = props.className,
      disabled = props.disabled,
      helpText = props.helpText,
      htmlFor = props.htmlFor,
      id = props.id,
      messageId = props.messageId,
      label = props.label,
      messageText = props.messageText,
      messageType = props.messageType,
      ariaLive = props.ariaLive,
      otherProps = (0, _objectWithoutProperties2["default"])(props, ["children", "className", "disabled", "helpText", "htmlFor", "id", "messageId", "label", "messageText", "messageType", "ariaLive"]);
  var classNames = (0, _classnames["default"])(['stx-field', {
    'stx-field--alert': messageType === 'alert' || messageType === 'error'
  }, {
    'stx-field--warning': messageType === 'warning'
  }, {
    'stx-field--success': messageType === 'success'
  }, {
    'stx-field--is-disabled': disabled
  }, className]);

  var renderMessageText = function renderMessageText() {
    return messageText && /*#__PURE__*/_react["default"].createElement("div", {
      className: "stx-field__message",
      "aria-live": ariaLive,
      id: messageId
    }, messageText);
  };

  var renderHelpText = function renderHelpText() {
    return helpText && /*#__PURE__*/_react["default"].createElement("div", {
      className: "stx-field__help-text"
    }, helpText);
  };

  return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({}, otherProps, {
    id: id,
    className: classNames
  }), label && /*#__PURE__*/_react["default"].createElement("label", {
    htmlFor: htmlFor,
    className: "stx-field__label"
  }, " ", label, " "), children, renderMessageText(), renderHelpText());
}

;
Field.defaultProps = {};
Field.propTypes = {
  /** Text for the label element in for the field */
  label: _propTypes["default"].node,

  /** Text for additional text that appears below the form control */
  helpText: _propTypes["default"].node,

  /** The 'for' attribute on the label to link it to the form control via ID */
  htmlFor: _propTypes["default"].string,

  /** The ID attribute for the field component */
  id: _propTypes["default"].string,

  /** Optional classNames for the field component */
  className: _propTypes["default"].string,

  /** Whether or not the field is disabled */
  disabled: _propTypes["default"].bool,

  /** The type of message to show */
  messageType: _propTypes["default"].oneOf(['success', 'warning', 'alert', '']),

  /** The aria-live attribute value that will be set on the message if one is given */
  ariaLive: _propTypes["default"].oneOf(['polite', 'assertive']),

  /** The text to display for the message */
  messageText: _propTypes["default"].string,

  /** A unique ID for the message element */
  messageId: _propTypes["default"].string,

  /** Child elements */
  children: _propTypes["default"].node
};
var _default = Field;
exports["default"] = _default;